import React from 'react'
import { UploadDataRecord } from '../types'

interface Props {
  uploadRecords: UploadDataRecord[]
}

const formatCurrency = (amount: number): string => '₹' + amount.toLocaleString('en-IN')

const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return '—'
  try {
    const d = new Date(dateStr)
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return dateStr
  }
}

const UploadDataFallbackView: React.FC<Props> = ({ uploadRecords }) => {
  if (!uploadRecords || uploadRecords.length === 0) {
    return <div className='text-muted text-center py-6'>No data available.</div>
  }

  const selfRecord = uploadRecords.find(
    (r) => (r.Relation || '').toLowerCase() === 'self'
  )
  const sumInsured = selfRecord?.SumInsured ? Number(selfRecord.SumInsured) : null
  const isFloater = (selfRecord?.PlanType || '').toLowerCase() === 'floater'

  return (
    <div>
      {/* Sum Insured Banner */}
      {sumInsured != null && sumInsured > 0 && (
        <div
          className='d-flex align-items-center justify-content-between rounded p-3 mb-4'
          style={{ backgroundColor: '#f0f7ff', border: '1px solid #d0e3ff' }}
        >
          <div>
            <span className='text-muted fs-8'>Sum Insured</span>
            <div className='fw-bolder fs-5 text-primary'>{formatCurrency(sumInsured)}</div>
          </div>
          <div className='text-end'>
            <span className='text-muted fs-8'>Lives</span>
            <div className='fw-bolder fs-5'>{uploadRecords.length}</div>
          </div>
        </div>
      )}

      {/* Family Members Table */}
      <div className='mb-5'>
        <h6 className='fw-bolder fs-6 mb-3'>Family Members</h6>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle fs-7'>
            <thead>
              <tr className='fw-bolder text-muted'>
                <th>Name</th>
                <th>Relation</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Sum Insured</th>
              </tr>
            </thead>
            <tbody>
              {uploadRecords.map((rec) => (
                <tr key={rec.sid}>
                  <td className='fw-bold'>{rec.Name}</td>
                  <td>{rec.Relation}</td>
                  <td>{formatDate(rec.DOB)}</td>
                  <td>{rec.Gender}</td>
                  <td className='fw-bold text-primary'>
                    {isFloater && (rec.Relation || '').toLowerCase() !== 'self'
                      ? '—'
                      : rec.SumInsured ? formatCurrency(Number(rec.SumInsured)) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default UploadDataFallbackView
